import { UIEvent } from 'react';

import { Tabs, TabList } from '@grupoboticario/flora-react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { PageInfo, ResponsiveFloraTypography } from 'components';
import { ORDERS_TABS } from 'config/environments/shared';

import { Payments, History } from './components';
import Styles from './Orders.styles';

const Orders = () => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTab = (event: UIEvent) => {
    const target = event.currentTarget as HTMLButtonElement;

    setSearchParams({
      tab:
        target.innerText.toLowerCase() === 'histórico' ? ORDERS_TABS.history : ORDERS_TABS.payments,
    });
  };

  return (
    <div>
      <PageInfo
        breadcrumbs={[
          {
            text: 'Pedidos',
            url: pathname,
          },
        ]}
      >
        <ResponsiveFloraTypography as='h1' fontSize='title' fontWeight='bold'>
          Pedidos
        </ResponsiveFloraTypography>
        <ResponsiveFloraTypography>
          Gerencie seus pagamentos e consulte informações sobre os pedidos realizados
        </ResponsiveFloraTypography>
      </PageInfo>

      <Styles.TabListWrapper>
        <Styles.Container size='large' data-autotagging-flora-section='pedidos'>
          <Tabs defaultValue={searchParams.get('tab') || ORDERS_TABS.payments}>
            <TabList aria-label='tabs example'>
              <Styles.Tab
                value={ORDERS_TABS.payments}
                onClick={handleTab}
                autotagging-flora='on'
                data-flora='button'
                data-flora-text='tab:a-pagar'
              >
                <ResponsiveFloraTypography fontWeight='medium'>A pagar</ResponsiveFloraTypography>
              </Styles.Tab>
              <Styles.Tab
                value={ORDERS_TABS.history}
                onClick={handleTab}
                autotagging-flora='on'
                data-flora='button'
                data-flora-text='tab:historico'
              >
                <ResponsiveFloraTypography fontWeight='medium'>Histórico</ResponsiveFloraTypography>
              </Styles.Tab>
            </TabList>

            <Styles.TabPanel value={ORDERS_TABS.payments}>
              <Payments />
            </Styles.TabPanel>
            <Styles.TabPanel value={ORDERS_TABS.history}>
              <History />
            </Styles.TabPanel>
          </Tabs>
        </Styles.Container>
      </Styles.TabListWrapper>
    </div>
  );
};

export default Orders;
